exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sorting-options{align-items:flex-start;display:flex;flex-direction:row;justify-content:flex-end}.sorting-options__header{align-items:center;margin-top:6px}\n", ""]);

// exports
exports.locals = {
	"sorting-options": "sorting-options",
	"sorting-options__header": "sorting-options__header"
};